import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("osk_token")) { setUser(false); setReady(true); return; }
    try { const { data } = await api.get("/auth/me"); setUser(data); }
    catch { localStorage.removeItem("osk_token"); setUser(false); }
    setReady(true);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const signIn = async (data) => { localStorage.setItem("osk_token", data.token); await refresh(); return data.user; };
  const logout = () => { localStorage.removeItem("osk_token"); setUser(false); };

  return <AuthCtx.Provider value={{ user, ready, signIn, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
export const dashboardPath = (u) => (u?.role === "admin" ? "/admin" : u?.role === "teacher" ? "/docent" : "/ouder");
